export { default, PAGE_HERO } from './PageHero';
export type { PageHeroProps } from './PageHero';
